import productSearchActionTypes from '../actionTypes/ProductSearchActionTypes';

const getProductSearchAction = (params, regionZone, version) => ({
    type: productSearchActionTypes.PRODUCTSEARCH_GET_REQUEST,
    params,
    regionZone,
    version,
});

const resetProductSearchResults = (value = []) => ({
    type: productSearchActionTypes.RESET_PRODUCTSEARCH_RESULTS,
    value,
});

export default {
    getProductSearchAction,
    resetProductSearchResults,
};
